<template>
  <USPWhy
    v-if="!$params.iframe"
    v-track:impression="{
      event: `homepage:popularDestinationLinksImpression`,
      params: { pos: route.path },
    }"
    class="adjust-background mt-4 bg-bgr-200 first:mt-0 md:mt-12"
    :why="[
      block.content.columns.content.left,
      block.content.columns.content.right,
    ]"
    @click:link="handleClickLink"
  />
</template>

<script setup lang="ts">
defineProps<{ block: Block<USPColumnsBlockContent> }>()

const route = useRoute()
const tracking = useTracking()

function handleClickLink(element: HTMLAnchorElement) {
  tracking.handlers?.homepage.popularDestinationLinksClick(
    element.innerText,
    route.path,
  )
}
</script>
